import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'caret'];

  connect() {
    this.closeTimeout = null;
    this.boundClose = this.close.bind(this);
    this.boundCloseAll = this.closeAll.bind(this);

    document.addEventListener('click', this.boundClose);
    document.addEventListener('dropdown:closeAll', this.boundCloseAll);
  }

  disconnect() {
    document.removeEventListener('click', this.boundClose);
    document.removeEventListener('dropdown:closeAll', this.boundCloseAll);
    clearTimeout(this.closeTimeout);
  }

  toggle(event) {
    event.stopPropagation();

    const isHidden = this.menuTarget.classList.contains('hidden');

    document.dispatchEvent(
      new CustomEvent('dropdown:closeAll', {
        bubbles: true,
        detail: { origin: this.element },
      })
    );

    if (isHidden) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    clearTimeout(this.closeTimeout);

    this.menuTarget.classList.remove('hidden');

    requestAnimationFrame(() => {
      this.menuTarget.classList.remove('scale-95', 'opacity-0');
      this.menuTarget.classList.add('scale-100', 'opacity-100');
    });

    if (this.hasCaretTarget) {
      this.caretTarget.classList.add('rotate-180');
    }
  }

  close(event) {
    if (event && this.element.contains(event.target)) return;

    clearTimeout(this.closeTimeout);

    this.menuTarget.classList.remove('scale-100', 'opacity-100');
    this.menuTarget.classList.add('scale-95', 'opacity-0');

    if (this.hasCaretTarget) {
      this.caretTarget.classList.remove('rotate-180');
    }

    this.closeTimeout = setTimeout(() => {
      this.menuTarget.classList.add('hidden');
    }, 200);
  }

  closeAll(event) {
    const origin = event.detail?.origin;

    if (this.element !== origin) {
      this.close();
    }
  }
}
